import { render, staticRenderFns } from "./Txet.vue?vue&type=template&id=1c0d7444&scoped=true&"
import script from "./Txet.vue?vue&type=script&lang=js&"
export * from "./Txet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c0d7444",
  null
  
)

export default component.exports